/**
 * Brazilian vehicle plate (placa) — old AAA-0000 and Mercosul AAA0A00 / AAA-0A00.
 */

export const PLATE_INVALID_MSG =
  'Placa inválida. Use o formato antigo (ABC-1234) ou Mercosul (ABC1D23).';

/** Alphanumeric uppercase, max 7 (no separators). */
export function stripPlate(value: string): string {
  return (value || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 7);
}

export function isOldPlate(raw: string): boolean {
  return /^[A-Z]{3}\d{4}$/.test(raw);
}

export function isMercosulPlate(raw: string): boolean {
  return /^[A-Z]{3}\d[A-Z]\d{2}$/.test(raw);
}

export function isValidPlate(value?: string | null): boolean {
  const raw = stripPlate(value || '');
  return isOldPlate(raw) || isMercosulPlate(raw);
}

/** Normalize for API/storage: ABC1D23 / ABC1234 (no hyphen). */
export function normalizePlate(value?: string | null): string {
  return stripPlate(value || '');
}

/**
 * Display: Mercosul AAA-0A00, old AAA-0000.
 * Best-effort hyphen after 3 chars for incomplete/legacy values.
 */
export function formatPlate(value?: string | null): string {
  const raw = stripPlate(value || '');
  if (!raw) return value ? String(value).trim() : '';
  if (raw.length <= 3) return raw;
  return `${raw.slice(0, 3)}-${raw.slice(3)}`;
}

/** Typing mask — inserts hyphen after the 3 letters. */
export function applyPlateMask(value: string): string {
  return formatPlate(value);
}
